import React from 'react';
import { ReactComponent as IconOk } from './ic-ok.svg';
import { ReactComponent as IconVk } from './ic-vk.svg';
import { ReactComponent as IconTw } from './ic-tw.svg';
import { ReactComponent as IconFb } from './ic-fb.svg';

import './styles.scss';

class Share extends React.Component {
    share = (type) => {
      const href = encodeURIComponent(`https://friends.mail.ru/?share_data=${this.props.result + 1}`);

      switch (type) {
        case 'ok':
  	      window.open(`https://connect.ok.ru/offer?url=${href}`, '', 'height=480,width=640');
  	      break;
  	    case 'vk':
  	      window.open(`http://vk.com/share.php?url=${href}`, '', 'height=480,width=640');
  	      break;
  	    case 'fb':
  	      window.open(`https://www.facebook.com/sharer/sharer.php?u=${href}`, '', 'height=480,width=640');
  	      break;
  	    case 'tw':
  	      window.open(`https://twitter.com/intent/tweet?url=${href}`, '', 'height=480,width=640');
  	      break;
  	    default:
  	      break;
  	  }
    }

    render() {
        return (
            <ul className="share">
              <li className="share__item">
                <div className="share__link" onClick={() => this.share('vk')} data-xray-click="share_vk">
                  <IconVk />
                </div>
              </li>
              <li className="share__item">
                <div className="share__link" onClick={() => this.share('ok')} data-xray-click="share_ok">
                  <IconOk />
                </div>
              </li>
              <li className="share__item">
                <div className="share__link -fb" onClick={() => this.share('fb')} data-xray-click="share_fb">
                  <IconFb />
                </div>
              </li>
              <li className="share__item">
                <div className="share__link -tw" onClick={() => this.share('tw')} data-xray-click="share_tw">
                  <IconTw />
                </div>
              </li>
            </ul>
        )
    }
}

export default Share;
